import { useState, useEffect, useMemo } from "react";
import dayjs from "dayjs";

import {
  AntTextArea,
  DatePicker,
  Select,
  Input as TextInput,
} from "components/Antd";
import {
  AutocompleteDebounce,
  CommonButton,
  MultipleInput,
  RippleEffect,
} from "components/UiElement";
import { Form, Formik } from "formik";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { handleKeyPress } from "utils";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { textFormatter } from "components/Formatter";
import { validation } from "./validation";
import { Step1Uploader, Step2Uploader, Step3Uploader } from "../Uploaders";

function StepOneForm({
  onSubmit,
  stateLoader,
  stateList,
  countryList,
  countryLoader,
  getStateValue,
  memorialData,
  loading,
  theme,
  imageArray,
  setImageArray,
  subscriptionData,
}) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [dod, setDod] = useState(false);
  const [siblings, setSiblings] = useState([]);
  const [children, setChildren] = useState([]);
  const [err, setErr] = useState(false);
  const [imageSize, setImageSize] = useState();
  const [coverImageSize, setCoverImageSize] = useState();
  const [imageArraySize, setImageArraySize] = useState([]);
  const [selectedBirthDate, setSelectedBirthDate] = useState(
    undefined || memorialData?.birthDate
  );
  const [selectedDeathhDate, setSelectedDeathDate] = useState(
    undefined || memorialData?.deathDate
  );

  const [selectedMarriageDate, setSelectedMarriageDate] = useState(undefined);
  useEffect(() => {
    if (
      memorialData?.birthDate !== null ||
      memorialData?.birthDate !== undefined
    ) {
      setSelectedBirthDate(dayjs(memorialData?.birthDate));
    }
    if (memorialData?.deathDate !== null) {
      setSelectedDeathDate(dayjs(memorialData?.deathDate));
    }
    if (memorialData?.dateOfMarriage !== null) {
      setSelectedMarriageDate(dayjs(memorialData?.dateOfMarriage));
    }
  }, [memorialData]);

  // const navigate = useNavigate();

  const siblingsArray = () => {
    if (memorialData && memorialData?.siblings) {
      const siblingsData = memorialData?.siblings?.map((item) => item.fullName);
      setSiblings(siblingsData);
    }
  };
  const childrenArray = () => {
    if (memorialData && memorialData?.children) {
      const childrenData = memorialData?.children?.map((item) => item.fullName);
      setChildren(childrenData);
    }
  };

  useEffect(() => {
    siblingsArray();
    childrenArray();
  }, [memorialData]);

  useEffect(() => {
    if (memorialData?.birthCountry?.id) {
      getStateValue(memorialData?.birthCountry?.id);
    }
    if (memorialData?.deathCountry?.id) {
      getStateValue(memorialData?.deathCountry?.id);
    }
  }, [memorialData]);

  useEffect(() => {
    if (imageArray?.length === 5) {
      setErr(false);
    }
  }, [imageArray]);

  const CoverImages = useMemo(() => {
    let arr = [];
    arr = imageArray?.map((item) => item?.basePath);
    return arr;
  }, [imageArray]);

  const initialValues = {
    firstName: memorialData?.firstName || "",
    middleName: memorialData?.middleName || "",
    lastName: memorialData?.lastName || "",
    fatherName: memorialData?.father?.fullName || "",
    motherName: memorialData?.mother?.fullName || "",
    siblings: undefined,
    birthCity: memorialData?.birthCity || "",
    birthDate: memorialData?.birthDate || undefined,
    deathDate: memorialData?.deathDate || undefined,
    deathCity: memorialData?.deathCity || "",
    spouseName: memorialData?.spouse?.fullName || "",
    children: undefined,
    myBio: memorialData?.myBio || "",
    bioLong: memorialData?.bioLong || "",
    instagram: memorialData?.instagram || "",
    facebook: memorialData?.facebook || "",
    twitter: memorialData?.twitter || "",
    birthStateId: memorialData?.birthStateId || undefined,
    deathStateId: memorialData?.deathStateId || undefined,
    maritalStatus: memorialData?.maritalStatus || "unmarried",
    dateOfMarriage: memorialData?.dateOfMarriage || null,
    profileImage: memorialData?.themeOnes?.[0]?.profileImage || "",
    coverImage: memorialData?.themeOnes?.[0]?.coverImage || "",
    birthCountryId: memorialData?.birthCountry?.id || undefined,
    deathCountryId: memorialData?.deathCountry?.id || undefined,
    location: memorialData?.location || undefined,
    lat: memorialData?.lat || "",
    long: memorialData?.long || "",
  };

  const relationStatus = [
    {
      id: "unmarried",
      name: "Single",
    },
    { id: "married", name: "Married" },

    {
      id: "divorced",
      name: "Divorced",
    },
    {
      id: "widower",
      name: "Widower",
    },
  ];

  return (
    <Formik
      initialValues={{ ...initialValues }}
      onSubmit={(val) => {
        let data = { ...val };
        data.lat = `${val.lat}`;
        data.long = `${val.long}`;

        data.birthDate =
          val.birthDate === null || val.birthDate === undefined
            ? null
            : dayjs(val.birthDate).format("YYYY-MM-DD");

        data.deathDate =
          val.deathDate === null || val.deathDate === undefined
            ? null
            : dayjs(val.deathDate).format("YYYY-MM-DD");
        data.dateOfMarriage =
          val.dateOfMarriage === undefined || val.dateOfMarriage === null
            ? null
            : dayjs(val.dateOfMarriage).format("YYYY-MM-DD");
        if (theme === "theme01") {
          data.usedStorage = Number(imageSize) + Number(coverImageSize);
        }
        if (theme === "theme02" || theme === "theme04") {
          data.usedStorage = Number(coverImageSize);
        }
        if (theme === "theme03") {
          data.usedStorage = imageArraySize?.reduce(
            (accumulator, currentValue) =>
              Number(accumulator) + Number(currentValue),
            0
          );
        }

        data.coverImage = theme === "theme03" ? CoverImages : val.coverImage;
        if (imageArray?.length < 5 && theme === "theme03") {
          setErr(true);
        } else {
          setErr(false);
          const filteredDatas = data?.siblings?.filter((item) => item !== "");
          const chidFilter = data?.children?.filter((item) => item !== "");
          data.siblings = filteredDatas;
          data.children = chidFilter;
          if (val.birthStateId === undefined) {
            data.birthStateId = null;
          }
          if (val.deathStateId === undefined) {
            data.deathStateId = null;
          }
          if (val.birthCountryId === undefined) {
            data.birthCountryId = null;
          }
          if (val.deathCountryId === undefined) {
            data.deathCountryId = null;
          }

          onSubmit(data, imageArray);
        }
      }}
      enableReinitialize
      validationSchema={validation(
        show,
        dod,
        theme,
        selectedDeathhDate,
        selectedBirthDate
      )}
    >
      {(props) => {
        const { values } = props;
        if (values.maritalStatus !== "unmarried") {
          setShow(true);
        } else {
          setShow(false);
        }

        if (
          values.deathDate === null ||
          values.deathDate === "" ||
          values.deathDate === undefined
        ) {
          setDod(false);
        } else {
          setDod(true);
        }

        return (
          <Form name="dynamic_form_item">
            <>
              <div className="basicInfo">
                <Row>
                  {theme !== "theme03" && (
                    <Col lg={3}>
                      {theme === "theme01" && (
                        <Step1Uploader
                          props={props}
                          memorialData={memorialData}
                          subscriptionData={subscriptionData}
                          setImageSize={setImageSize}
                          setCoverImageSize={setCoverImageSize}
                        />
                      )}
                      {(theme === "theme02" || theme === "theme04") && (
                        <Step2Uploader
                          props={props}
                          memorialData={memorialData}
                          theme={theme}
                          subscriptionData={subscriptionData}
                          setCoverImageSize={setCoverImageSize}
                        />
                      )}
                    </Col>
                  )}
                  <Col lg={theme === "theme03" ? 12 : 9}>
                    {theme === "theme03" && (
                      <>
                        <Step3Uploader
                          props={props}
                          memorialData={memorialData}
                          setImageArray={setImageArray}
                          imageArray={imageArray}
                          setImageArraySize={setImageArraySize}
                          imageErr={err}
                          subscriptionData={subscriptionData}
                          imageArraySize={imageArraySize}
                        />
                      </>
                    )}
                    <div className="commonCard bg-white">
                      <div className="commonCard_head">
                        <h2 className="mb-0">
                          <span>01</span>
                          {t("text.createMemories.basicInfo")}
                        </h2>
                      </div>
                      <Row className="g-3">
                        <Col md={4} sm={6}>
                          <div className="form-group mb-0">
                            <label className="form-label">
                              {t("text.createMemories.firstName")}
                            </label>
                            <TextInput
                              id="fname"
                              name="firstName"
                              className="form-control"
                              placeholder={t("text.userAuth.enterFirstName")}
                              setFieldValues={props.handleChange}
                              maxLength={50}
                            />
                          </div>
                        </Col>
                        <Col md={4} sm={6}>
                          <div className="form-group mb-0">
                            <label className="form-label">
                              {t("text.createMemories.middleName")}
                            </label>
                            <TextInput
                              id="mname"
                              name="middleName"
                              className="form-control"
                              placeholder={t("text.userAuth.enterMiddleName")}
                              setFieldValues={props.handleChange}
                              maxLength={50}
                            />
                          </div>
                        </Col>
                        <Col md={4} sm={6}>
                          <div className="form-group mb-0">
                            <label className="form-label">
                              {t("text.createMemories.lastName")}
                            </label>
                            <TextInput
                              id="lname"
                              name="lastName"
                              className="form-control"
                              placeholder={t("text.userAuth.enterLastName")}
                              setFieldValues={props.handleChange}
                              maxLength={50}
                            />
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="form-group mb-0">
                            <label className="form-label">
                              {t("text.createMemories.fatherName")}
                            </label>
                            <TextInput
                              id="faname"
                              name="fatherName"
                              className="form-control"
                              maxLength={50}
                              placeholder={t(
                                "text.createMemories.enterFatherName"
                              )}
                              setFieldValues={props.handleChange}
                            />
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="form-group mb-0">
                            <label className="form-label">
                              {t("text.createMemories.motherName")}
                            </label>
                            <TextInput
                              id="moname"
                              name="motherName"
                              className="form-control"
                              placeholder={t(
                                "text.createMemories.enterMotherName"
                              )}
                              maxLength={50}
                              setFieldValues={props.handleChange}
                            />
                          </div>
                        </Col>
                        <Col sm={12}>
                          <MultipleInput
                            props={props}
                            defaultArray={siblings}
                            names="siblings"
                            Name={t("text.createMemories.siblingName")}
                            maxLength={50}
                          />
                        </Col>
                        <Col sm={6}>
                          <div className="form-group mb-0">
                            <label className="form-label d-flex align-items-center">
                              {t("text.createMemories.pinLocation")}{" "}
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip className="tooltip">
                                    {t(
                                      "text.createMemories.pinLocationTooltip"
                                    )}
                                  </Tooltip>
                                }
                              >
                                <span className="iconInfo align-items-center justify-content-center d-inline-flex rounded-circle cursor-pointer">
                                  <em className="icon-info" />
                                </span>
                              </OverlayTrigger>
                            </label>
                            <AutocompleteDebounce
                              defaultValue={memorialData?.location}
                              validation
                              name="location"
                              placeholder="Enter Location"
                              setFieldValue={props.handleChange}
                              onKeyPress={handleKeyPress}
                              callBack={(val) => {
                                props.setFieldValue(
                                  "location",
                                  val?.formatted_address
                                );
                                props.setFieldValue(
                                  "lat",
                                  `${val?.geometry?.location?.lat()}`
                                );
                                props.setFieldValue(
                                  "long",
                                  `${val?.geometry?.location?.lng()}`
                                );

                                let city = "";
                                let state = "";
                                let country = "";
        
                                val?.address_components.forEach((component) => {
                                  if (component.types.includes("locality")) {
                                    city = component.long_name;
                                  } else if (component.types.includes("administrative_area_level_1")) {
                                    state = component.long_name;
                                  } else if (component.types.includes("country")) {
                                    country = component.long_name;
                                  }
                                });
                                props.setFieldValue("city", city);  
                                props.setFieldValue("state", state);
                                props.setFieldValue("country", country);
                              }}
                            />{" "}
                          </div>
                        </Col>
                        <Col xs={12}>
                          <div className="form-group mb-0">
                            <label className="form-label">
                              {t("text.createMemories.myBio")}
                            </label>
                            <AntTextArea
                              className="form-control form-control-textarea"
                              placeholder={t("text.createMemories.typeHere")}
                              setFieldValues={props.handleChange}
                              name="myBio"
                              maxLength={1000}
                            />
                          </div>
                        </Col>
                        {(theme === "theme03" || theme === "theme04") && (
                          <>
                            <Col xs={12}>
                              <div className="form-group mb-0">
                                <label className="form-label">Long Bio</label>
                                <AntTextArea
                                  className="form-control form-control-textarea"
                                  placeholder={t(
                                    "text.createMemories.typeHere"
                                  )}
                                  setFieldValues={props.handleChange}
                                  name="bioLong"
                                  maxLength={1000}
                                />
                              </div>
                            </Col>
                          </>
                        )}
                      </Row>
                    </div>{" "}
                    <div className="commonCard bg-white">
                      <div className="commonCard_head">
                        <h2 className="mb-0">
                          {t("text.createMemories.birthDetails")}
                        </h2>
                      </div>
                      <Row>
                        <Col md={6} sm={6}>
                          <div className="form-group">
                            <label className="form-label">
                              {t("text.createMemories.birthDate")}
                              <span className="form-label-date">
                                [MM-DD-YYYY]
                              </span>
                            </label>
                            <DatePicker
                              validation
                              placeholder={t(
                                "text.createMemories.selectBirthDate"
                              )}
                              className="form-control"
                              suffixIcon={<em className="icon-calendar" />}
                              onSelectChange={(e) => {
                                setSelectedBirthDate(e);
                                props.setFieldValue("birthDate", e);
                              }}
                              name="birthDate"
                              defaultValue={
                                memorialData?.birthDate === null ||
                                memorialData?.birthDate === undefined
                                  ? undefined
                                  : selectedBirthDate
                              }
                              disabledDate={(current) => {
                                return (
                                  current && current > dayjs().endOf("day")
                                );
                              }}
                            />
                          </div>
                        </Col>
                        <Col md={6} sm={6}>
                          <div className="form-group">
                            <label className="form-label d-block">
                              {t("text.createMemories.birthCountry")}
                            </label>
                            <Select
                              placeholder={t("text.userAuth.selectCountry")}
                              setFieldValue={props.handleChange}
                              name="birthCountryId"
                              loading={countryLoader}
                              callback={(value) => {
                                getStateValue(value);
                                props.setFieldValue("birthStateId", undefined);
                                props.setFieldValue("birthCity", "");
                              }}
                              filterOption={(input, option) => {
                                return (
                                  option.key
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0 ||
                                  option.title
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                );
                              }}
                              showSearch
                            >
                              {countryList?.length > 0 &&
                                countryList?.map((item) => {
                                  return (
                                    <option
                                      key={item?.name}
                                      value={item?.id}
                                      title={item?.name}
                                    >
                                      {textFormatter(item?.name)}
                                    </option>
                                  );
                                })}
                            </Select>
                          </div>
                        </Col>
                        {stateList.length > 0 && (
                          <Col md={6} sm={6}>
                            <div className="form-group mb-sm-0">
                              <label className="form-label d-block">
                                {t("text.createMemories.birthState")}
                              </label>
                              <Select
                                placeholder={t("text.userAuth.selectState")}
                                setFieldValue={props.handleChange}
                                name="birthStateId"
                                loading={stateLoader}
                                callback={() => {
                                  props.setFieldValue("birthCity", "");
                                }}
                                filterOption={(input, option) => {
                                  return (
                                    option.key
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0 ||
                                    option.title
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  );
                                }}
                                showSearch
                              >
                                {stateList.length > 0 &&
                                  stateList?.map((item) => {
                                    return (
                                      <option
                                        key={item?.name}
                                        value={item?.id}
                                        title={item?.name}
                                      >
                                        {item?.name}
                                      </option>
                                    );
                                  })}
                              </Select>
                            </div>
                          </Col>
                        )}

                        <Col md={6} sm={6}>
                          <div className="form-group mb-0">
                            <label className="form-label d-block">
                              {t("text.createMemories.birthCity")}
                            </label>
                            <TextInput
                              id="birth"
                              name="birthCity"
                              className="form-control fieldicon-input-right"
                              maxLength={15}
                              placeholder={t(
                                "text.createMemories.EnterBirthCity"
                              )}
                              setFieldValues={props.handleChange}
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>{" "}
                    <div className="commonCard bg-white">
                      <div className="commonCard_head">
                        <h2 className="mb-0">
                          {t("text.createMemories.deathDetails")}
                        </h2>
                      </div>
                      <Row className="g-3">
                        <Col md={6} sm={6}>
                          <div className="form-group mb-0">
                            <label className="form-label">
                              {" "}
                              {t("text.createMemories.deathDate")}
                              <span className="form-label-date">
                                [MM-DD-YYYY]
                              </span>
                            </label>
                            <DatePicker
                              validation
                              className="form-control"
                              placeholder={t(
                                "text.createMemories.selectDeathDate"
                              )}
                              suffixIcon={<em className="icon-calendar" />}
                              name="deathDate"
                              onSelectChange={(e) => {
                                setSelectedDeathDate(e);
                                props.setFieldValue("deathDate", e);
                              }}
                              defaultValue={
                                memorialData?.deathDate === null
                                  ? undefined
                                  : selectedDeathhDate
                              }
                              disabledDate={(current) => {
                                const { birthDate, dateOfMarriage } =
                                  props?.values || {};
                                return (
                                  current &&
                                  (current > dayjs().endOf("day") ||
                                    (birthDate &&
                                      current <
                                        dayjs(birthDate).startOf("day")) ||
                                    (dateOfMarriage &&
                                      current <
                                        dayjs(dateOfMarriage).startOf("day")))
                                );
                              }}
                            />
                          </div>
                        </Col>
                        {dod === true && (
                          <>
                            <Col md={6} sm={6}>
                              <div className="form-group mb-0">
                                <label className="form-label d-block">
                                  {t("text.createMemories.deathCountry")}
                                </label>
                                <Select
                                  placeholder={t("text.userAuth.selectCountry")}
                                  setFieldValue={props.handleChange}
                                  name="deathCountryId"
                                  callback={(value) => {
                                    getStateValue(value);
                                    props.setFieldValue(
                                      "deathStateId",
                                      undefined
                                    );
                                    props.setFieldValue("deathCity", "");
                                  }}
                                  loading={stateLoader}
                                  filterOption={(input, option) => {
                                    return (
                                      option.key
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0 ||
                                      option.title
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    );
                                  }}
                                  showSearch
                                >
                                  {countryList?.length > 0 &&
                                    countryList?.map((item) => {
                                      return (
                                        <option
                                          key={item?.name}
                                          value={item?.id}
                                          title={item?.name}
                                        >
                                          {textFormatter(item?.name)}
                                        </option>
                                      );
                                    })}
                                </Select>
                              </div>
                            </Col>{" "}
                            {stateList?.length > 0 && (
                              <Col md={6} sm={6}>
                                {stateList?.length > 0 && (
                                  <div className="form-group mb-0">
                                    <label className="form-label d-block">
                                      {t("text.createMemories.deathState")}
                                    </label>
                                    <Select
                                      placeholder={t(
                                        "text.userAuth.selectState"
                                      )}
                                      setFieldValue={props.handleChange}
                                      name="deathStateId"
                                      loading={stateLoader}
                                      callback={() => {
                                        props.setFieldValue("deathCity", "");
                                      }}
                                      filterOption={(input, option) => {
                                        return (
                                          option.key
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >=
                                            0 ||
                                          option.title
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        );
                                      }}
                                      showSearch
                                    >
                                      {stateList?.length > 0 &&
                                        stateList?.map((item) => {
                                          return (
                                            <option
                                              key={item?.name}
                                              value={item?.id}
                                              title={item?.name}
                                            >
                                              {item?.name}
                                            </option>
                                          );
                                        })}
                                    </Select>
                                  </div>
                                )}
                              </Col>
                            )}
                            <Col md={6} sm={6}>
                              <div className="form-group mb-0">
                                <label className="form-label d-block">
                                  {" "}
                                  {t("text.createMemories.deathCity")}
                                </label>
                                <TextInput
                                  id="death"
                                  name="deathCity"
                                  className="form-control"
                                  placeholder={t(
                                    "text.createMemories.EnterDeathCity"
                                  )}
                                  setFieldValues={props.handleChange}
                                />
                              </div>
                            </Col>
                          </>
                        )}
                      </Row>{" "}
                    </div>{" "}
                    <div className="commonCard bg-white">
                      <div className="commonCard_head">
                        <h2 className="mb-0">
                          {t("text.createMemories.marriageDetails")}
                        </h2>
                      </div>
                      <Row className="g-3">
                        <Col md={4} sm={6}>
                          <div className="form-group mb-0">
                            <label className="form-labeld-block">
                              {t("text.createMemories.maritalStatus")}
                            </label>
                            <Select
                              placeholder={t(
                                "text.userAuth.relationStatusSelect"
                              )}
                              setFieldValue={props.handleChange}
                              name="maritalStatus"
                            >
                              {relationStatus?.map((item, index) => {
                                return (
                                  <option key={index} value={item?.id}>
                                    {item?.name}
                                  </option>
                                );
                              })}
                            </Select>
                          </div>
                        </Col>
                        {show && props.values.maritalStatus !== undefined && (
                          <>
                            <Col md={4} sm={6}>
                              <div className="form-group mb-0">
                                <label className="form-label">
                                  {t("text.createMemories.dateOfMarriage")}
                                  <span className="form-label-date">
                                    [MM-DD-YYYY]
                                  </span>
                                </label>
                                <DatePicker
                                  validation
                                  className="form-control"
                                  name="dateOfMarriage"
                                  placeholder={t(
                                    "text.createMemories.selectMarriageDate"
                                  )}
                                  suffixIcon={<em className="icon-calendar" />}
                                  setFieldValues={props.handleChange}
                                  onSelectChange={(e) => {
                                    setSelectedMarriageDate(e);
                                    props.setFieldValue("dateOfMarriage", e);
                                  }}
                                  defaultValue={
                                    memorialData?.dateOfMarriage === null
                                      ? undefined
                                      : selectedMarriageDate
                                  }
                                  disabledDate={(current) => {
                                    return (
                                      current &&
                                      (current > dayjs().endOf("day") ||
                                        current >
                                          dayjs(
                                            props?.values?.deathDate
                                          ).startOf("day"))
                                    );
                                  }}
                                />
                              </div>
                            </Col>
                            <Col md={4} sm={6}>
                              <div className="form-group mb-0">
                                <label className="form-label d-block">
                                  {t("text.createMemories.spouseName")}
                                </label>
                                <TextInput
                                  id="spouse"
                                  name="spouseName"
                                  className="form-control"
                                  setFieldValues={props.handleChange}
                                  placeholder={t(
                                    "text.createMemories.EnterSpouseName"
                                  )}
                                  maxLength={50}
                                />
                              </div>
                            </Col>
                            <Col sm={12}>
                              <MultipleInput
                                props={props}
                                defaultArray={children}
                                names="children"
                                Name={t("text.createMemories.childrenName")}
                                maxLength={50}
                              />
                            </Col>
                          </>
                        )}
                      </Row>{" "}
                      {/* <Row className="g-3">
                        <MultipleInput
                          props={props}
                          defaultArray={children}
                          names="children"
                          Name={t("text.createMemories.childrenName")}
                        />
                      </Row> */}
                    </div>
                    <div className="commonCard bg-white">
                      <div className="commonCard_head">
                        <h2 className="mb-0">
                          {t("text.createMemories.socialMediaLink")}
                        </h2>
                      </div>

                      <div className="form-group">
                        <label className="form-label d-block">
                          {t("text.createMemories.instagram")}
                        </label>
                        <TextInput
                          id="instagram"
                          name="instagram"
                          className="form-control"
                          placeholder={t("text.createMemories.typeHere")}
                          setFieldValues={props.handleChange}
                          maxLength={150}
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label d-block">
                          {t("text.createMemories.facebook")}
                        </label>
                        <TextInput
                          id="facebook"
                          name="facebook"
                          className="form-control"
                          setFieldValues={props.handleChange}
                          placeholder={t("text.createMemories.typeHere")}
                          maxLength={150}
                        />
                      </div>
                      <div className="form-group mb-0">
                        <label className="form-label d-block">
                          {t("text.createMemories.twitter")}
                        </label>
                        <TextInput
                          id="twitter"
                          name="twitter"
                          className="form-control"
                          placeholder={t("text.createMemories.typeHere")}
                          setFieldValues={props.handleChange}
                          maxLength={150}
                        />
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end mt-40">
                      {/* <RippleEffect>
                        <Link
                          className="btn btn-light me-2 me-md-3"
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(-1);
                          }}
                        >
                          {t("text.common.goBack")}
                        </Link>
                      </RippleEffect> */}
                      <RippleEffect>
                        <CommonButton
                          className="btn btn-danger"
                          type="submit"
                          loading={loading}
                        >
                          {t("text.common.next")}
                        </CommonButton>
                      </RippleEffect>
                    </div>
                  </Col>
                </Row>
              </div>
            </>
          </Form>
        );
      }}
    </Formik>
  );
}

export default StepOneForm;
